import network from '@/utils/network'
import store from '@/store'

/**
 * Soumet une demande de parrainage
 * @returns {Promise<>}
 */
export const postSponsor = async (sponsor) => {
  const r = await network.post(`sponsor`, sponsor)
  return r.data
}

/**
 * Soumet un fichier en upload
 * @returns {Promise<>}
 */
export const postUpload = async (file) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.post(`agency/${slugAgency}/upload`, file)
  return r.data
}

/**
 * Soumet un fichier en download
 * @returns {Promise<>}
 */
export const getDownload = async (url) => {
  const r = await network.get(`download`, { params: { url } })
  return r.data
}

/**
 * Récupère les cas d'utilisation d'un badge
 * @param {string} badge
 * @returns {Promise<>}
 */
export const getBadgeInfos = async (badge = '') => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.get(`agency/${slugAgency}/badge-infos/${badge}`)
  return r.data
}

/**
 * Récupère le numéro de version requis depuis le serveur
 * @return {Promise<>}
 */
export const getAppVersion = async () => {
  const { data } = await network.get('/version')
  return data
}

/**
 * Récupère un fichier zip de tout les fichiers envoyés
 */
export const getZip = async (urls) => {
  const r = await network.post('/zip', { urls })
  return r.data
}
